import { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setBookmarksPopup } from "../../model/actions";
import { Star } from "../icons";

import "./BookmarksButton.scss";

function BookmarksButton() {
  const dispatch = useDispatch();
  const bookmarksPopup = useSelector((state) => state.bookmarksPopup);

  const onClick = useCallback(() => {
    dispatch(setBookmarksPopup(!bookmarksPopup));
  }, [bookmarksPopup, dispatch]);

  return (
    <div
      className="map-control"
      id="bookmarks-button"
      onClick={onClick}
      onKeyPress={(e) => e.which === 13 && onClick()}
      role="button"
      tabIndex="0"
    >
      <Star />
    </div>
  );
}

export default memo(BookmarksButton);
